import { render } from "./Figc.vue?vue&type=template&id=3c1930b0&scoped=true"
import script from "./Figc.vue?vue&type=script&lang=js"
export * from "./Figc.vue?vue&type=script&lang=js"

import "./Figc.vue?vue&type=style&index=0&id=3c1930b0&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1930b0"]])

export default __exports__